import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { IndosbookMark } from "./IndosbookLogo";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white">
        <IndosbookMark size={44} />
        <Loader2 className="h-5 w-5 animate-spin text-[#FF4500]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin/dashboard" replace />;
  if (!user.role) return <Navigate to="/onboarding" replace />;

  return children;
};

export default ProtectedRoute;
